$(document).ready(function() {
    $('.datatables').DataTable({
        //autoWidth: false,
        bPaginate: true,
        bInfo: false,
        order: [[ 2, "asc" ]],
        columnDefs: [
            {
                "targets": [ 3 ],
                "visible": false
            }
        ],
        searchCols: [
                null,
                null,
                null,
                {"search": 'Abierta'}
        ],
        renderer: 'foundation',
        dom:
        "<'row collapse'<'medium-6 medium-push-6 columns cercadorTaula'f><'medium-6 medium-pull-6 columns'<'toolbar'>>'>r"+
        "t"+
        "<'pagination-centered'p>",
        language: {
            "zeroRecords": "No se ha encontrado ninguna entrada",
            "infoEmpty": "Ninguna entrada disponible",
            "search": "",
            "paginate": {
                "first": "Primera",
                "last": "Última",
                "next": "Siguiente",
                "previous": "Anterior"
            }
        }


    });
    $(".convocatorias div.toolbar").html('<ul class="filters"><li class="opened active"><a data-filter="Abierta" href="#">Abiertas</a></li><li class="future"><a data-filter="Prevista" href="#">Previstas</a></li><li class="closed"><a data-filter="Cerrada" href="#">Cerradas</a></li></ul>');

    $(".convocatorias div.toolbar a").click(function(event){
        event.preventDefault();
        $('.toolbar .active').removeClass('active');
        var oTable = $('.datatables').dataTable();
        var valor = $(this).data('filter');
        $(this).parent().addClass('active');
        oTable.fnFilter( valor , 3 );
    });
});
